import React from "react";

import { ReactComponent as ArrowLeftAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_left_alt.svg";
import { ReactComponent as LocationOnIcon } from "./../../assets/images/icons/Google SVGs/location_on.svg";
import { ReactComponent as ChatIcon } from "./../../assets/images/icons/Google SVGs/chat.svg";
import { ReactComponent as CallIcon } from "./../../assets/images/icons/Google SVGs/call.svg";
import { ReactComponent as VideoIcon } from "./../../assets/images/icons/Google SVGs/videocam.svg";

const ShiftCard = (props) => {
  return (
    <div className="card border-1 border-bootstrap-gray-300 background-bootstrap-gray-100 rounded-2 w-100">
      <div className="card-body p-2 d-flex flex-row">
        <div className="col d-flex flex-column">
          <span className="mt-0 mb-auto fs-14 fw-normal color-bootstrap-gray-800">
            {props.place}
          </span>

          <span className="mt-1 mb-3 fs-14 fw-normal color-bootstrap-gray-600">
            {props.department}
          </span>
          <div className="d-flex align-items-center">
            <span className="d-flex rounded w-fit h-fit p-0 px-2 m-0 fs-14 fw-normal background-bootstrap-gray-200 color-bootstrap-gray-700 align-items-center">
              <span>{props.start.substring(0, 5)}</span>
              <ArrowLeftAltIcon width={16} height={16} className="mx-1" />
              <span>{props.end.substring(0, 5)}</span>
            </span>

            <span
              className={`d-flex rounded w-fit h-fit p-1 m-0 fs-14 fw-normal ${
                props.hasInPerson == 1
                  ? "color-iso-blue-300 bg-iso-blue-100"
                  : "text-white background-bootstrap-gray-200"
              } align-items-center ms-auto`}
            >
              <LocationOnIcon width={16} height={16} />
            </span>

            <span
              className={`d-flex rounded w-fit h-fit p-1 m-0 fs-14 fw-normal ${
                props.hasText == 1
                  ? "color-iso-blue-300 bg-iso-blue-100"
                  : "text-white background-bootstrap-gray-200"
              } align-items-center ms-2`}
            >
              <ChatIcon width={16} height={16} />
            </span>

            <span
              className={`d-flex rounded w-fit h-fit p-1 m-0 fs-14 fw-normal ${
                props.hasVoiceCall == 1
                  ? "color-iso-blue-300 bg-iso-blue-100"
                  : "text-white background-bootstrap-gray-200"
              } align-items-center ms-2`}
            >
              <CallIcon width={16} height={16} />
            </span>

            <span
              className={`d-flex rounded w-fit h-fit p-1 m-0 fs-14 fw-normal ${
                props.hasVideoCall == 1
                  ? "color-iso-blue-300 bg-iso-blue-100"
                  : "text-white background-bootstrap-gray-200"
              } align-items-center ms-2`}
            >
              <VideoIcon width={16} height={16} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ShiftCard;
